<script setup lang="ts">
</script>

<template>
  <div class="flex flex-row justify-between items-center gap-2 hover:bg-primary hover:bg-opacity-70 px-2 py-1 rounded-md w-full text-neutral-content text-sm whitespace-nowrap cursor-pointer" :tabindex="0">
    <slot />
  </div>
</template>
